import { ResourceContainer } from 'ohzi-core';
import { Time } from 'ohzi-core';
import { Debug } from 'ohzi-core';
import { SceneManager } from 'ohzi-core';

import { Box3 } from 'three';
import { BoxBufferGeometry } from 'three';
import { Mesh } from 'three';
import { Object3D } from 'three';
import { MeshBasicMaterial } from 'three';
import { Vector3 } from 'three';

import BuildingMaterial from '../../materials/BuildingMaterial';
import Icon2D from '../Icon2D';

export default class GenericBuildingGroup extends Object3D {

	constructor (main_building, stop, camera_position) {
		super();
		const ctx = this;
    	this.main_building = main_building
    	this.name = main_building.name;

		this.add(main_building)

    	this.selected = false;
    	this.lerp = 0;
    	this.sub_scenes = [];

    	let children = []
    	for (let i = 0; i < this.main_building.children.length; i++) {
    		children.push(this.main_building.children[i]);
    	}

    	for (let i = 0; i < children.length; i++) {
    		let object = children[i];

    		if (object.name.includes('box')) {
				object.updateMatrixWorld(true)
    			object.visible = false;

    			this.box = object.geometry;
    			this.box.applyMatrix4(object.matrix);

    			this.main_building.remove(object)
    			continue;
    		}

    		if ( (	object.name.includes('antenna') ||
    				object.name.includes('glass') ||
    				object.name.includes('truck') ||
    				object.name.includes('solar_panel') ||
    				object.name.includes('person') ||
    				object.name.includes('cctv') )
    			&& !object.name.includes('position') && !object.name.includes('lookat') && !object.name.includes('solar_panel_solar_panel')) {
    			
    			if (!stop) {
    			 	object = new GenericBuildingGroup(object, true);
					this.add_subscene(object);

					let data;
					if (object.name.includes('antenna') || object.name.includes('solar_panel')) {
						data = camera_position['solar'];
					} 
					if (object.name.includes('glass')) {
						data = camera_position['gate'];
					} 
					if (object.name.includes('truck')) {
						data = camera_position['lte'];
					} 
					if (object.name.includes('person')) {
						data = camera_position['radio'];
					} 
					if (object.name.includes('cctv')) {
						data = camera_position['cctv'];
					} 
					if(data) {
						let position = new Vector3(data.position.x,data.position.y, data.position.z);
						let target = new Vector3(data.target.x,data.target.y, data.target.z);
						let tilt = data.tilt;
						let orientation = data.orientation;

						object.set_scene_camera_configuration(position,target,tilt,orientation);
					}
    			}
				continue;
    		}


    		if (object.name.includes('position')) {
    			this.camera_position_object = object
    			object.visible = false;
    			continue;
    		}

    		if (object.name.includes('lookat') || object.name.includes('solar_panel_solar_panel')) {
				this.camera_target_object = object
    			object.visible = false;
    			continue;
    		}

    	}

    	this.convert_to_custom_shader();

	}

	compute_bbox () {

		let config = ResourceContainer.get_resource('config');

		this.sub_scenes.forEach((sub_scene)=>{
			sub_scene.compute_bbox();
		})

		let places = ResourceContainer.get_resource('config').places
		if(places[this.name]) {
			this.icon = new Icon2D(places[this.name], "hi", this.main_building, this, places[this.name].icon, 200);
			let position = places[this.name].position;
			this.icon.position.set(position.x, position.y, position.z)
		} else {
    		let services = Object.entries( ResourceContainer.get_resource('config').services)
			for (let i = 0; i < services.length; i++) {

				if (this.name.includes(services[i][0]) && !this.name.includes('position') && !this.name.includes('lookat')) {
					let image;
					let sub_title;
				
					if (this.name.includes("person")) {
						image = "radio"
					}
					if (this.name.includes("truck")) {
						image = "lte"
					}
					if (this.name.includes("glass")) {
						image = "fence"
					}
					if (this.name.includes("cctv")) {
						image = "cctv"
					}
					if (this.name.includes("antenna")) {
						image = "solar"
					}
					if (this.name.includes("lollapalooza")) {
						sub_title = "Festivals and Concerts"
					}
					if (this.name.includes("centre")) {
						sub_title = "Tradeshows, Meetings and Special Events"
					}
					if (this.name.includes("factory")) {
						sub_title = "Industrial Solutions"
					}
					if (this.name.includes("stadium")) {
						sub_title = "Sporting Events"
					}
					if (this.name.includes("golf")) {
						sub_title = "Pro Golf"
					}

					this.icon = new Icon2D(services[i][1], sub_title, this.main_building, this, image);
					break
				}
			}
		}

	};

	convert_to_custom_shader() {
		this.main_building.traverse((obj)=>{
			if (obj.material && obj.material.map && !obj.name.includes("InstancedMesh")) {
				obj.material = new BuildingMaterial(obj.material, obj);
			} 
		})
	};

	clear_raycasteable_mesh() {
	}

	set_parent(a_sub_scene) {
		this.parent_scene = a_sub_scene;
	}

	add_subscene(sub_scene) {
		this.sub_scenes.push(sub_scene);
		sub_scene.set_parent(this);
		this.main_building.add(sub_scene)
	}

	get subscenes () {
		return this.sub_scenes;
	}

	get_raycasteables() {
		const raycasteables = this.sub_scenes.map((sub_scene)=>{
			if (sub_scene.icon) {
				return sub_scene.icon
			}
		});

		return raycasteables;
	}

	animate() {
		this.update_material_alpha(1)
	}

	highlight(aBoolean) {
		this.selected = aBoolean;
	}	

	update_material_alpha(lerper) {
		this.main_building.traverse(((obj)=>{
			if (obj.material && obj.material.set_alpha) {
				obj.material.set_alpha(lerper);
			}
		}).bind(this))	
	}

	update_material() {
		this.main_building.traverse(((obj)=>{
			if (obj.material && obj.material.update) {
				obj.material.update();
			}
		}).bind(this));

		this.sub_scenes.forEach((object)=>{
			object.update_material();
		})
	}

	fade_out(lerper) {
		this.sub_scenes.forEach((object)=>{
			object.fade_out(lerper);
			object.update_material_alpha(lerper);
		})

		if(this.icon) {
			this.icon.fade_out(lerper)
		}
	}

	fade_in(lerper, show_icon) {
		this.sub_scenes.forEach((object)=>{
			object.fade_in(lerper, true);
		})
		this.update_material_alpha(lerper);

		if(this.icon && show_icon) {
			this.icon.fade_in(lerper)
		}
	}

	update () {

		this.lerp = this.selected ? this.lerp + Time.delta_time : this.lerp - Time.delta_time;
		this.lerp = Math.min(Math.max(this.lerp, 0.0), 1.0);

		this.sub_scenes.forEach((element)=>{
			element.animate();
		})

		if (this.icon)
			this.icon.update();
	}

	set_scene_camera_configuration(camera_position, camera_target, tilt, orientation, fov) {
		this.camera_position = camera_position;
		this.camera_target = camera_target;
		this.tilt = tilt;
		this.orientation = orientation;
		this.fov = 50;
	}

}